import React from "react";
import BaseComponent from 'Core/components/BaseComponent';
import {connect} from 'react-redux';
import {getPageActions} from 'Core/helpers/redux';
import SelectInput from 'Core/components/input/SelectInput';
import {get, omit} from 'lodash';
import PropTypes from 'prop-types';
import * as actions from 'Pages/apps/default/customerSegments/actions'

/**
 * Get all actions used by this component
 * @type {Object}
 */
const allActions = getPageActions(actions);

class CustomerSegmentSelectInput extends BaseComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			/** @type {CustomerSegmentsItemDataObject[]|{label: string, value: string}|null|undefined} */
			customerSegmentList: null,
			/** @type {boolean} */
			customerSegmentListLoading: false,
		}
		
		// Data methods
		this.loadOptions = this.loadOptions.bind(this);
	}

	/** @inheritDoc */
	async asyncComponentDidMount() {
		await super.asyncComponentDidMount();

		// Load select options
		await this.loadOptions();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		// Re-load select options when project ID or client ID changes
		if (this.props.projectId !== prevProps.projectId || this.props.clientId !== prevProps.clientId) {
			this.loadOptions().then();
		}
	}

	/**
	 * Load select options
	 * @param {boolean} [onMount=false] - Specifies if this method is called as part of the component mount cycle.
	 * @return {Promise<void>}
	 */
	async loadOptions(onMount = false) {
		const {projectId, clientId, useDefaultOptionFormat, fetchCustomerSegmentsListAction} = this.props;
		const executeAbortableAction = (onMount ? this.executeAbortableActionMount : this.executeAbortableAction);
		
		await this.setState({customerSegmentListLoading: true})
			.then(() => executeAbortableAction(fetchCustomerSegmentsListAction,
				{projectIds: !!projectId ? [projectId] : [], clientId: clientId || null}, 1, 999999
			))
			.then(res => get(res, 'data'))
			.then(
				/**
				 * @param {CustomerSegmentsListItemDataObject[]|undefined} list
				 * @return {Promise<Object>}
				 */
				list => this.setState({
					customerSegmentList: (
						useDefaultOptionFormat ?
							list.map(i => ({id: i.id, label: i.name, value: i.id})) :
							list
					)
				})
			)
			.finally(() => this.setState({customerSegmentListLoading: false}));
	}

	render() {
		const {useDefaultOptionFormat} = this.props;
		const {customerSegmentList, customerSegmentListLoading} = this.state;

		return (
			<SelectInput
				{...omit(this.props, ['projectId', 'clientId', ...Object.keys(allActions)])}
				primaryKey={useDefaultOptionFormat ? 'value' : 'id'}
				options={!!customerSegmentList ? customerSegmentList : []}
				isLoading={customerSegmentListLoading}
				getOptionValue={o => useDefaultOptionFormat ? o.value : o.id}
				getOptionLabel={o =>
					// (!!o.id && o.id !== '-1' ? `[${o.id}] ` : '') +
					(useDefaultOptionFormat ? o.label : o.name)
				}
			/>
		);
	}
}

/**
 * Define component's own props that can be passed to it by parent components
 */
CustomerSegmentSelectInput.propTypes = {
	...SelectInput.propTypes,
	
	projectId: PropTypes.string,
	clientId: PropTypes.string,
	useDefaultOptionFormat: PropTypes.bool,
};

/**
 * Define component default values for own props
 */
CustomerSegmentSelectInput.defaultProps = {
	useDefaultOptionFormat: false,
};

export default connect(null, allActions, null, {forwardRef: true})(CustomerSegmentSelectInput);